import {
  TransferMoveUnconfirmedError,
  TransferNotRecordedError,
  TransferNotSentError,
  TransferOutcomeUnknownError,
  type TransferPayload
} from '../../../project_starburst/interface/transfer';

export function toTransferCaseInput(payload: TransferPayload, guid: string) {
  return {
    process_instance_guid: guid,
    destination:
      payload.destination.kind === 'user'
        ? { kind: 'USER', worker_id: payload.destination.id }
        : { kind: 'QUEUE', collection_id: payload.destination.id },
    reasons: payload.reasons.map((reason) => ({
      key: reason.key,
      label: reason.label
    })),
    ...(payload.note ? { note: payload.note } : {}),
    ...(payload.caseContext ? { case_context: payload.caseContext } : {})
  };
}

const UNCERTAIN_OUTCOME_MESSAGE =
  'The transfer may not have completed. Check the case owner in the worklist.';

interface CodedError {
  readonly message?: string;
  readonly extensions?: { readonly code?: string };
}

export function toTransferError(error: unknown): Error {
  const failure = error as
    | {
        graphQLErrors?: ReadonlyArray<CodedError>;
        networkError?: { result?: { errors?: ReadonlyArray<CodedError> } };
      }
    | undefined;
  const first: CodedError | undefined =
    failure?.graphQLErrors?.[0] ?? failure?.networkError?.result?.errors?.[0];
  const code = first?.extensions?.code;
  const message = first?.message ?? UNCERTAIN_OUTCOME_MESSAGE;
  switch (code) {
    case 'TRANSFER_NOT_SENT':
    case 'TRANSFER_FORBIDDEN':
    case 'TRANSFER_NOT_CONFIRMED':
      return new TransferNotSentError(message);
    case 'GRAPHQL_VALIDATION_FAILED':
      return new TransferNotSentError(
        "Transfer isn't available yet. Nothing was moved."
      );
    case 'TRANSFER_MOVE_UNCONFIRMED':
      return new TransferMoveUnconfirmedError(message);
    case 'TRANSFER_NOT_RECORDED':
      return new TransferNotRecordedError(message);
    case 'TRANSFER_OUTCOME_UNKNOWN':
      return new TransferOutcomeUnknownError(message);
    default:
      return new Error(UNCERTAIN_OUTCOME_MESSAGE);
  }
}
